function Container({ children }) {
  return (
    <div className="border rounded-[6px] border-cv-blue-200 bg-white px-6 py-2 flex gap-[15px] justify-center">
      {children}
    </div>
  )
}

function Title({ children }) {
  return (
    <div className="text-sm font-bold text-cv-blue-400 flex gap-2 items-center mb-2 mt-2">
      {children}
    </div>
  )
}

function Content({ children }) {
  return (
    <div className="font-extrabold text-cv-blue-600 flex flex-col items-center justify-center w-auto h-full">
      {children}
    </div>
  )
}

function Details({ children }) {
  return (
    <div className="flex gap-[15px] items-center h-full">
      <div className="w-[1px] h-full bg-cv-blue-200" />
      <div className="flex gap-2 items-center">{children}</div>
    </div>
  )
}

export function IntegrationCard({ children }: { children: React.ReactNode }) {
  return <div className="max-w-[170px]">{children}</div>
}

IntegrationCard.Container = Container
IntegrationCard.Title = Title
IntegrationCard.Content = Content
IntegrationCard.Details = Details
